import { createQueryKeys } from '@lukemorales/query-key-factory';

import { get } from '@/api/api';

export const AUTH_URI = 'auth';

export interface Permission {
  id: string;
  description: string;
}

export const authQueries = createQueryKeys(AUTH_URI, {
  all: null,
  permissions: {
    queryKey: ['permissions'] as const,
    queryFn: async () => {
      const response = await get<Permission[]>({ uri: `${AUTH_URI}/permissions` });
      return response.data;
    },
  },
});
